const sanitiseValue = (value: string, defaultValue?: '' | null | undefined) => {
  if (value === '' || value === 'null' || value === 'undefined' || value == null || value === undefined) {
    return defaultValue;
  }
  return value;
};
export default sanitiseValue;
